module.exports = __webpack_public_path__ + "static/media/ic_back.16ec6d58.svg";